<div class="prefix-wrapper">
  <ng-content select="[prefix]"></ng-content>
</div>

<input
  #input
  [type]="type"
  [disabled]="disabled"
  [attr.readOnly]="readOnly ? '' : null"
  [attr.autocomplete]="autocompleteName || null"
  [placeholder]="placeholder || ''"
  [attr.maxlength]="maxLength"
  [attr.tabindex]="tabIndex"
  [style.width]="width"
  (input)="handleChange($any($event.target).value)"
  (focus)="focus.emit($event)"
  (blur)="blur.emit($event)"
  text-primary
/>

<div class="suffix-wrapper">
  <rt-spinner *ngIf="loading" variant="small"></rt-spinner>
  <rt-icon
    *ngIf="hasDropdownIndicator"
    (click)="setFocus()"
    name="arrow-drop-down"
    class="dropdown-indicator"
  ></rt-icon>
  <rt-icon-button
    #clearButton
    *ngIf="isRemoveButtonVisible()"
    (click)="onRemoveButtonClick($event)"
    variant="plain"
    iconName="close"
    shape="square"
    size="small"
  ></rt-icon-button>
  <ng-content select="[suffix]"></ng-content>
</div>
